import { useEffect } from 'react'
import { useNotificationToast } from '@context/NotificationToastContext'
import { createFailedToast } from '@utils/notificationToast.util'

export const REPORTS_FINANCE_LOADING_CONTAINER = '.reports-patient-base-health'

type UseReportFinanceUiEffectsOptions = {
  loading: boolean
  error: string | null | undefined
  errorTitle?: string
  errorMessage?: string
  loadingContainer?: string
}

export function useReportFinanceUiEffects({
  loading,
  error,
  errorTitle = 'Failed to load report',
  errorMessage = 'Failed to load report data. Please try again.',
}: UseReportFinanceUiEffectsOptions): void {
  const { showToast } = useNotificationToast()

  useEffect(() => {
    if (!loading && error) {
      showToast(createFailedToast(errorTitle, errorMessage))
    }
  }, [loading, error, errorTitle, errorMessage, showToast])
}
